module.exports = __webpack_public_path__ + "static/3-001-3710180f2b2d568ddce73f9c819797cf.mp4";